module.exports = __webpack_public_path__ + "img/1alB-a'a-za'a.22084fc8.jpg";